import styled from 'styled-components';

export const OfferNotification = styled.img`
  width: 6px;
  height: 6px;
  margin-right: 3px;
  border: 3px solid ${({ theme }) => theme.COLORS.TERTIARY};
  border-radius: 50%;
  align-self: center;
`;

export const OfferValue = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const OfferValueWrapper = styled.div`
  height: min-content;
  display: flex;
  flex-direction: row;
`;

export const StyledCurrentOffer = styled.div`
  background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  padding: 14px;
  padding: ${({ isSelling }) =>
    isSelling ? '10px 18px 8px' : '13px 18px 11px'};
`;
